import React from 'react';

export default function Checkbox({ label, className = '', ...props }) {
  return (
    <label className={`checkbox ${className}`}>
      <input type="checkbox" className="checkbox__input" {...props} />
      <span>{label}</span>
    </label>
  );
}
